import React from 'react';
import TooltipWrapper from './TooltipWrapper';
import TooltipImage from './tooltip.svg';

const Tooltip = ({
  className,
  handleMouseOver,
  handleMouseLeave,
  handleClick,
  tooltipText,
  position,
  ...rest
}) => {
  return (
    <TooltipWrapper
      className={className}
      onClick={handleClick}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      tooltipText={tooltipText}
      position={position}
      {...rest}
    >
      <img src={TooltipImage} alt="tooltip" />
    </TooltipWrapper>
  );
};

export default Tooltip;
